import { inject, PLATFORM, resolve } from "aurelia";
import { I18N } from "@aurelia/i18n";
import { IRouter } from "@aurelia/router";
import { IStore } from "@aurelia/state";

import spacetime from "spacetime";

import { toggleTheme as toggleThemeUtil } from "@/helpers/util";
import { TLanguage } from "@/interfaces";
import { Api } from "@/services/api";
import {
  CHANGE_LANGUAGE,
  ChangeLanguageAction,
  LOGOUT,
  LogoutAction,
  TOGGLE_DARK_MODE,
  TOGGLE_SIDEBAR,
} from "@/static/storeActions";
import { IState } from "@/store/state";

@inject(Api)
export class MtTopbar {
  private time = "";

  private readonly store: IStore<IState, LogoutAction | ChangeLanguageAction> = resolve(
    IStore
  ) as IStore<IState, LogoutAction | ChangeLanguageAction>;
  private router: IRouter = resolve(IRouter);
  private readonly i18n: I18N = resolve(I18N);

  constructor(private api: Api) {
    this.updateTime();
  }

  private toggleNavMenu() {
    this.store.dispatch({ type: TOGGLE_SIDEBAR });
  }

  private logout() {
    this.api.logout().finally(() => {
      this.store.dispatch({ type: LOGOUT });
      this.router.load("login");
    });
  }

  private routeToMain() {
    this.router.load("");
  }

  private toggleTheme() {
    // Call util function
    toggleThemeUtil();
    // Dispatch action
    this.store.dispatch({ type: TOGGLE_DARK_MODE });
  }

  private changeLanguage(lang: TLanguage) {
    this.i18n.setLocale(lang); // ? Should it be here
    // Dispatch action
    this.store.dispatch({ type: CHANGE_LANGUAGE, payload: lang });
  }

  private updateTime() {
    // TODO update when taskQueue is fixed
    setInterval(() => {
      this.time = spacetime.now().format("iso-utc");
    }, 1000);
  }
}
